import { useSelector } from "react-redux";
import AuthorisationModalAction from "@common/redux/actions/AuthorisationModalAction";

const useAuthorisation = () => {
  const data = useSelector((state) =>
    AuthorisationModalAction.getStatePath(state),
  );

  const { open } = data;

  const setState = (data) => AuthorisationModalAction.dispatch(data);

  const toggleAuthorisationModal = () => setState({ open: !open });

  const onChange = (event) => {
    setState({ comments: event.target.value });
  };

  return { ...data, toggleAuthorisationModal, onChange };
};

export default useAuthorisation;
